<template>
  <div class="istanbul-travel">
    <paper-card :bg="colors.tan">
        <h1>A Quick Guide to Traveling to Istanbul</h1>
        
        <h2>Travel</h2>
        <ul>
            <li>
                <h3>Do non-Turkish citizens need visa?</h3>
                <b>Yes.</b>
                <p>
                You’d need to get electronic visa from <a href="https://www.evisa.gov.tr/en/">https://www.evisa.gov.tr/en/</a> 
                It’s a multi-entry 90 days visa, for $20 that can be paid online. 
                </p>
                <p>
                You can apply for your approximate arrival date, it will be issued 
                electronically and you’d need to have a printout with you just in 
                case (they also see it on the system while you’re entering from the border) 
                </p>
                <p>
                <b>Please use the link we provided</b>, there are other middle man services 
                that costs more and they imitate the government website.
                </p>
            </li>

            <li>
                <h3>Which airport we should come to?</h3>
                <p>
                Istanbul has 2 international airports; 
                Sabiha Gokcen on the Asian side and 
                the new Istanbul Airport on the European side. 
                </p>
                <p>
                Direct US flights land to the Istanbul Airport. 
                Our wedding will be on the Asian side, 
                but we will have boats leaving from each side.
                </p>
            </li>

            <li>
                <h3>When should we come?</h3>
                <p>
                The wedding is on <b>Sunday June 16th, 8pm</b> local time. 
                Consider the flight time + getting over jetlag 
                before finding yourself on the dance floor.
                </p>
                
                <p>
                There will be additional wedding festivities before the wedding, 
                check your invitations for details.
                </p>
            </li>

        </ul>

        <h2>Where should we stay?</h2>
        <ul>
            <li>
                <p>
                    Either side (European or Asian) will have boats
                    to our wedding venue, check out the places you
                    would like to see in Istanbul and ask us for
                    recommendations directly if you’d like :)
                </p>
            </li>
            <li>
                <p>
                    Kabatas / Besiktas / Ortakoy on the European side 
                    that has ferry, tram, bus access to the Old City (Sultanahmet) 
                    is one of the most convenient places to stay. 
                </p>
                <p>
                    It will be easy to come to the wedding and you can walk by the shore, 
                    access touristic places easily. 
                </p>
            </li>
            <li>
                <p>
                    Beyoglu, Karakoy are also places that are cool to stay in.
                </p>
            </li>
        </ul>

        <h2>Sightseeing</h2>
        <ul>
            <li>
                <h3>How Do We Get Around?</h3>
                <p>
                    <b>Uber is banned</b> because of taxation, but yellow taxis 
                    are very common everywhere, you can stop them by just waving.
                </p>
                <p>
                    There are bus, metro, trams and boats as well.
                </p>
            </li>
            <li>
                <h3>Where in Istabul &amp; Turkey we must visit?</h3>
                <p>
                    Depends on the duration of your stay, and interests. In every town, there is lots of things for everyone. Looking for beaches to enjoy Mediterranean Sea: tons of blue flag beaches on the coasts, looking for history: well it’s Turkey, so you’ll get that in everywhere by default. Check out this website for ideas and don’t hesitate to reach out for recommendations: 
                    <a href="https://www.touropia.com/best-places-to-visit-in-turkey/">https://www.touropia.com/best-places-to-visit-in-turkey</a>
                </p>
            </li>
        </ul>

        <h2>Power, Chargers, Phones, &amp; Data</h2>
        <ul>
            <li>
                <h3>Turkey Uses European Plugs</h3>
                <p>
                That's the plug with two round pegs.
                A US to European converter should work.
                <a href="https://www.amazon.com/Ckitze-Europe-Travel-Power-Adapter/dp/B001EB26MO">Something like this.</a>
                </p>
            </li>

            <li>
                <h3>There is Good Wifi Availablity</h3>
                <p>
                Most cafes will offer Wifi. Some touristic 
                areas will have Wifi hotspots as well.
                </p>
            </li>

            <li>
                <h3>Check Your Phone Plan</h3>
                <p>
                Check your phone plans for international phone/data usage.
                They may be offering day based or monthly based plans.
                </p>

                <p>
                You can get pay-as-go simcards as well. 
                These can be swapped into your phone, or you can bring an 
                old phone to use with the sim card.
                Make sure your phone is GSM (compatible with European networks)
                and unlocked (if you bought your phone from a carrier you may 
                have to call them to get it unlocked allowing you to use it 
                on another network).
                </p>

                <p>
                If you don't want to use international data make sure you 
                disable data on your phone during your flight.
                </p>

            </li>
        </ul>
    </paper-card>
  </div>
</template>

<script>
import PaperCard from '@/components/PaperCard.vue'
import { colors } from '@/colors.js'

export default {
  components: {
      PaperCard
  },
  data () {
      return { colors };
  },
}
</script>

<style lang="scss">
@import '@/colors.scss';

.istanbul-travel {
    background-color: $color-coral;
    padding: 30px;
    li {
        line-height: 1.25em;
        margin-bottom: 1em;
        font-family: 'Georgia', 'Times New Roman', Times, serif
    }
    h1 {
        padding-bottom: 10px;
    }
}
@media (max-width: 520px) {
    .istanbul-travel {
        padding: 10px;
        h1 {
            text-align: center;
        }
    }
}
</style>